/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateFormaFisicoQuimicaFormDto } from '../models/create-forma-fisico-quimica-form-dto';
import { FormaFisicoQuimicaCriteriaDto } from '../models/forma-fisico-quimica-criteria-dto';
import { FormaFisicoQuimicaDto } from '../models/forma-fisico-quimica-dto';
import { FormaFisicoQuimicaPageDto } from '../models/forma-fisico-quimica-page-dto';
import { UpdateFormaFisicoQuimicaFormDto } from '../models/update-forma-fisico-quimica-form-dto';


/**
 * Formas Fisico-Quimicas
 */
@Injectable({
  providedIn: 'root',
})
export class FormasFisicoQuimicasService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getFormasFisicoQuimicas
   */
  static readonly GetFormasFisicoQuimicasPath = '/formas-fisico-quimicas';

  /**
   * Pesquisar formas fisico-quimicas.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFormasFisicoQuimicas()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormasFisicoQuimicas$Response(params?: {
    criteria?: FormaFisicoQuimicaCriteriaDto;
  }): Observable<StrictHttpResponse<FormaFisicoQuimicaPageDto>> {

    const rb = new RequestBuilder(this.rootUrl, FormasFisicoQuimicasService.GetFormasFisicoQuimicasPath, 'get');
    if (params) {
      rb.query('criteria', params.criteria, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormaFisicoQuimicaPageDto>;
      })
    );
  }

  /**
   * Pesquisar formas fisico-quimicas.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFormasFisicoQuimicas$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormasFisicoQuimicas(params?: {
    criteria?: FormaFisicoQuimicaCriteriaDto;
  }): Observable<FormaFisicoQuimicaPageDto> {

    return this.getFormasFisicoQuimicas$Response(params).pipe(
      map((r: StrictHttpResponse<FormaFisicoQuimicaPageDto>) => r.body as FormaFisicoQuimicaPageDto)
    );
  }

  /**
   * Path part for operation createFormaFisicoQuimica
   */
  static readonly CreateFormaFisicoQuimicaPath = '/formas-fisico-quimicas';

  /**
   * Criar forma fisico-quimica.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFormaFisicoQuimica()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFormaFisicoQuimica$Response(params?: {

    /**
     * apiRequest
     */
    body?: CreateFormaFisicoQuimicaFormDto
  }): Observable<StrictHttpResponse<FormaFisicoQuimicaDto>> {

    const rb = new RequestBuilder(this.rootUrl, FormasFisicoQuimicasService.CreateFormaFisicoQuimicaPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormaFisicoQuimicaDto>;
      })
    );
  }

  /**
   * Criar forma fisico-quimica.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createFormaFisicoQuimica$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFormaFisicoQuimica(params?: {

    /**
     * apiRequest
     */
    body?: CreateFormaFisicoQuimicaFormDto
  }): Observable<FormaFisicoQuimicaDto> {

    return this.createFormaFisicoQuimica$Response(params).pipe(
      map((r: StrictHttpResponse<FormaFisicoQuimicaDto>) => r.body as FormaFisicoQuimicaDto)
    );
  }

  /**
   * Path part for operation getFormaFisicoQuimica
   */
  static readonly GetFormaFisicoQuimicaPath = '/formas-fisico-quimicas/{id}';

  /**
   * Obter forma fisico-quimica.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getFormaFisicoQuimica()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormaFisicoQuimica$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<FormaFisicoQuimicaDto>> {

    const rb = new RequestBuilder(this.rootUrl, FormasFisicoQuimicasService.GetFormaFisicoQuimicaPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormaFisicoQuimicaDto>;
      })
    );
  }

  /**
   * Obter forma fisico-quimica.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getFormaFisicoQuimica$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getFormaFisicoQuimica(params: {
    id: number;
  }): Observable<FormaFisicoQuimicaDto> {

    return this.getFormaFisicoQuimica$Response(params).pipe(
      map((r: StrictHttpResponse<FormaFisicoQuimicaDto>) => r.body as FormaFisicoQuimicaDto)
    );
  }

  /**
   * Path part for operation updateFormaFisicoQuimica
   */
  static readonly UpdateFormaFisicoQuimicaPath = '/formas-fisico-quimicas/{id}';

  /**
   * Atualizar forma fisico-quimica.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateFormaFisicoQuimica()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormaFisicoQuimica$Response(params: {
    id: number;
    body?: UpdateFormaFisicoQuimicaFormDto
  }): Observable<StrictHttpResponse<FormaFisicoQuimicaDto>> {

    const rb = new RequestBuilder(this.rootUrl, FormasFisicoQuimicasService.UpdateFormaFisicoQuimicaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormaFisicoQuimicaDto>;
      })
    );
  }

  /**
   * Atualizar forma fisico-quimica.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateFormaFisicoQuimica$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateFormaFisicoQuimica(params: {
    id: number;
    body?: UpdateFormaFisicoQuimicaFormDto
  }): Observable<FormaFisicoQuimicaDto> {

    return this.updateFormaFisicoQuimica$Response(params).pipe(
      map((r: StrictHttpResponse<FormaFisicoQuimicaDto>) => r.body as FormaFisicoQuimicaDto)
    );
  }

  /**
   * Path part for operation ativarFormaFisicoQuimica
   */
  static readonly AtivarFormaFisicoQuimicaPath = '/formas-fisico-quimicas/{id}/ativar';

  /**
   * Ativar forma fisico-quimica.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `ativarFormaFisicoQuimica()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarFormaFisicoQuimica$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<FormaFisicoQuimicaDto>> {

    const rb = new RequestBuilder(this.rootUrl, FormasFisicoQuimicasService.AtivarFormaFisicoQuimicaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormaFisicoQuimicaDto>;
      })
    );
  }

  /**
   * Ativar forma fisico-quimica.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `ativarFormaFisicoQuimica$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  ativarFormaFisicoQuimica(params: {
    id: number;
  }): Observable<FormaFisicoQuimicaDto> {

    return this.ativarFormaFisicoQuimica$Response(params).pipe(
      map((r: StrictHttpResponse<FormaFisicoQuimicaDto>) => r.body as FormaFisicoQuimicaDto)
    );
  }

  /**
   * Path part for operation desativarFormaFisicoQuimica
   */
  static readonly DesativarFormaFisicoQuimicaPath = '/formas-fisico-quimicas/{id}/desativar';

  /**
   * Desativar forma fisico-quimica.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `desativarFormaFisicoQuimica()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarFormaFisicoQuimica$Response(params: {
    id: number;
  }): Observable<StrictHttpResponse<FormaFisicoQuimicaDto>> {

    const rb = new RequestBuilder(this.rootUrl, FormasFisicoQuimicasService.DesativarFormaFisicoQuimicaPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FormaFisicoQuimicaDto>;
      })
    );
  }

  /**
   * Desativar forma fisico-quimica.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `desativarFormaFisicoQuimica$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  desativarFormaFisicoQuimica(params: {
    id: number;
  }): Observable<FormaFisicoQuimicaDto> {

    return this.desativarFormaFisicoQuimica$Response(params).pipe(
      map((r: StrictHttpResponse<FormaFisicoQuimicaDto>) => r.body as FormaFisicoQuimicaDto)
    );
  }

}
